<div class="overview-skeleton">
  <div class="overview-skeleton__header">
    <p-skeleton width="180px" height="32px" borderRadius="6px" />
    <div class="overview-skeleton__actions">
      <p-skeleton width="120px" height="40px" borderRadius="6px" />
      <p-skeleton width="150px" height="40px" borderRadius="6px" />
    </div>
  </div>

  <div class="overview-skeleton__toolbar">
    <p-skeleton width="320px" height="40px" borderRadius="6px" />
    <p-skeleton width="82px" height="38px" borderRadius="6px" />
  </div>

  <div class="overview-skeleton__grid">
    @for (i of Array(8).fill(0); track $index) {
      <p-skeleton height="200px" borderRadius="12px" />
    }
  </div>
</div>
